<template lang="pug">
.row
  .col.s12
    .container-fluid
      ul.collapsible(data-collapsible='accordion')
        li
          .collapsible-header.active
            i.material-icons info_outline
            | Details
          //- div.collapsible-body
          AppResellerDetails(
            :reseller='reseller',
            @updated='onSupplierUpdated',
            @created='onSupplierCreated',
            ref='supplierDetails'
          )
        li
          .collapsible-header.active
            i.material-icons business
            | Business Information
          //- div.collapsible-body
          AppResellerBUsinessDetails(:reseller='resellers')
        li
          .collapsible-header.active
            i.material-icons supervisor_account
            |
            | Officers and Affiliates, Subsidiaries and Branches
          //- div.collapsible-body
          AppResellerOfficerDetails(:reseller='resellers', :pdocs='photoDocs')
        li
          .collapsible-header.active
            i.material-icons call_to_action
            | Bank Information
          //- div.collapsible-body
          AppResellerBankDetails(:reseller='resellers')

        //- li(v-if='!supplier.new')
        //-     div.collapsible-header
        //-         i.material-icons supervisor_account
        //-         | Accounts
        //-     div.collapsible-body
        //-         app-supplier-accounts(:supplier='completeSupplier')
        //- li(v-if='!isApplicant && !isNew')
        //-     div.collapsible-header
        //-         i.material-icons store
        //-         | Shops
        //-     div.collapsible-body
        //-         app-supplier-shops(:supplier='supplier')
</template>
<script>
/* eslint-disable no-undef */
import AppResellerDetails from '@/components/app-reseller-details'
import AppResellerBUsinessDetails from '@/components/app-reseller-business-details'
import AppResellerBankDetails from '@/components/app-bank-details'
import AppResellerOfficerDetails from '@/components/app-officer-details'
import axios from 'axios'

export default {
  props: ['reseller'],
  data() {
    return {
      completeSupplier: this.supplier,
      resellers: [],
      photoDocs: [],
    }
  },
  mounted() {
    this.$M.Collapsible.init(document.querySelectorAll('.collapsible'))
    // axios.get(`${this.$config.API_URL}/suppliers/${this.supplier.code}`, {
    //   params: {
    //     includeAccounts: true
    //   }
    // }).then(result => {
    //   this.$set(this, 'completeSupplier', result.data)
    // })
    this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
      axios
        .get(
          `${this.$config.API_URL}/admin/reseller/${this.reseller.accountId}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params: this.$route.query,
          }
        )
        .then((result) => {
          this.resellers = result.data
          let dtiLink = result.data.docs[0].filePath.split('public/')
          let Link2303 = result.data.docs[1].filePath.split('public/')
          this.photoDocs = [
            { dti: `${this.$config.API_URL}/` + dtiLink[1] },
            { img2303: `${this.$config.API_URL}/` + Link2303[1] },
          ]
        })
    })
  },
  computed: {
    isApplicant() {
      return this.supplier.status === 'application'
    },
    isNew() {
      if (this.supplier !== null) {
        return this.supplier.new === true
      }
    },
    mutableSupplier() {
      return this.$refs.supplierDetails.mutableSupplier
    },
  },
  methods: {
    onSupplierUpdated(supplier) {
      this.$emit('updated', supplier)
    },
    onSupplierCreated(supplier) {
      this.$emit('created', supplier)
    },
  },
  components: {
    AppResellerDetails,
    AppResellerBUsinessDetails,
    AppResellerOfficerDetails,
    AppResellerBankDetails,
  },
}
</script>




// WEBPACK FOOTER //
// src/components/app-reseller.vue